import { getAxiosConfig } from 'fe-common'
import { from, concatMap, tap, of } from 'rxjs'
import { refreshToken } from '../../modules/client/utilities'

export default {
  namespaced: true,
  state: () => ({
    balances: [],
    getBalancesLoading: false,

    // 代理推廣鏈結
    promotionLinks: []
  }),
  actions: {
    getBalances(context, { config = {} } = { config: {} }) {
      const { commit } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/game/getAllBalance`,
                {},
                getAxiosConfig(context, { ...config, timeout: 10 * 1000 })
              )
            )
          ),
          // 因 res.data 回傳為陣列
          // filter(data =>
          //   checkAxiosData(data, {
          //     handleMessages: handleMessages({
          //       store: context
          //     })
          //   })
          // ),
          concatMap(data => {
            if (!Array.isArray(data)) {
              data = []
            }
            return of(data)
          }),
          concatMap(data => {
            if (!data.every(item => typeof item.data.platform === 'string')) {
              data = []
            }
            return of(data)
          }),
          tap(data => {
            commit('BALANCES', data)
          })
        )
        .toPromise()
    },
    getPromotionLinks(context) {
      return from(refreshToken(context))
        .pipe(() =>
          from(
            this.$axios.$post(
              `/webapi/agent/getSubAddress`,
              {},
              getAxiosConfig(context)
            )
          )
        )
        .toPromise()
    }
  },
  mutations: {
    BALANCES(state, payload) {
      state.balances = payload
    },
    GET_BALANCES_LOADING(state, payload) {
      state.getBalancesLoading = payload
    },

    PROMOTION_LINKS(state, payload) {
      state.promotionLinks = payload
    }
  },
  getters: {
    balances: state => state.balances,
    getBalancesLoading: state => state.getBalancesLoading,

    promotionLinks: state => state.promotionLinks
  }
}
